import __regexp from './__ios-regexp';
/** Detect the iOS */
export default function isIOS(ua) {
	return __regexp.test(ua);
}
